/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import detectIt from 'detect-it';

const useInfiniteScroll = (callback, scrollElement) => {
  const [isFetching, setIsFetching] = useState(false);

  function handleScroll() {
    const pageHeight = scrollElement
      ? scrollElement.scrollHeight
      : document.documentElement.offsetHeight;

    const windowHeight = scrollElement
      ? scrollElement.offsetHeight
      : window.innerHeight;
    const scrollPosition = scrollElement
      ? scrollElement.scrollTop
      : window.scrollY ||
        window.pageYOffset ||
        document.body.scrollTop +
          ((document.documentElement && document.documentElement.scrollTop) ||
            0);

    if (pageHeight - 350 <= windowHeight + scrollPosition) {
      if (!isFetching) setIsFetching(true);
    }
  }

  useEffect(() => {
    if (scrollElement) {
      scrollElement.addEventListener(
        'scroll',
        handleScroll,
        detectIt.passiveEvents === true
          ? { capture: false, passive: true }
          : false
      );
      return () => scrollElement.removeEventListener('scroll', handleScroll);
    }
    window.addEventListener(
      'scroll',
      handleScroll,
      detectIt.passiveEvents === true
        ? { capture: false, passive: true }
        : false
    );
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!isFetching) return;
    const timeout = setTimeout(callback(), 100);
    return () => clearTimeout(timeout);
  }, [isFetching]);

  return [isFetching, setIsFetching];
};

export default useInfiniteScroll;
